import React from 'react';
import styled from 'styled-components';
import {FAQSection} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {FaqItem} from '../types';
import {QuestionsAccordion} from './questions-accordion';
import {useFeatureAppId} from '../utils/use-feature-app-id';
import {useComponent} from '../component-library';

export function useQuestionsData(
  translations: FAQSection
): Record<string, FaqItem> {
  const baseId = useFeatureAppId();

  return React.useMemo(() => {
    const faqData: Record<string, FaqItem> = {};

    for (const [faqKey, translation] of Object.entries(translations)) {
      if (translation && translation.heading && translation.body) {
        faqData[faqKey] = {
          id: `${baseId}faq-item-${faqKey}`,
          question: translation.heading,
          answer: translation.body,
        };
      }
    }

    return faqData;
  }, [baseId, translations]);
}

export interface QuestionsSectionProps {
  translations: FAQSection;
}

export const QuestionsSection = (props: QuestionsSectionProps): JSX.Element => {
  const {translations} = props;

  const questionData = useQuestionsData(translations);

  const Text = useComponent('Text');
  const arialabel = translations.ariaLabel;

  const items = React.useMemo(
    () => Object.values(questionData),
    [questionData]
  );

  return (
    <section aria-label={arialabel}>
      <Text bold tag="h2" textAlign="center" variant="headline">
        {translations.header.heading}
      </Text>
      <LayoutWrapper>
        <QuestionsAccordion items={items} />
      </LayoutWrapper>
    </section>
  );
};

const LayoutWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  overflow: hidden;
`;
